export const questionnaire_B1 = {
    name: '問卷 B-1',
    subtitle: '以下題目與你的「線上閱讀」經驗有關。<br/>本問卷中的「線上閱讀」，是指使用電腦、平板或手機，圍繞同一主題，閱讀網頁或學習平台上的多份材料。材料可以包含文字、圖片、圖表等。<br/>請根據自己平時的實際情況回答，題目沒有對錯。',
    sections: [
        [
            {
                id: 'A',
                title: 'A　對線上閱讀的看法',
                hint: '以下題目詢問你對線上閱讀的一般看法。你在多大程度上同意或不同意以下陳述？',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我認為，透過線上閱讀學到的內容，可以運用到其他地方。' },
                    { question: '我認為，線上閱讀對我的學習很有用。' },
                    { question: '對我來說，理解線上閱讀中的內容很重要。' },
                    { question: '對我來說，進行線上閱讀很重要。' },
                    { question: '我對線上閱讀很感興趣。' },
                    { question: '我喜歡線上閱讀。' }
                ]
            }
        ],
        [
            {
                id: 'B',
                title: 'B　線上閱讀的信心',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我確信我可以有效地找到有用的材料。' },
                    { question: '我確信我可以評估材料的可信程度。' },
                    { question: '我確信我能理解文本中的資訊。' },
                    { question: '我有信心能理解文本中的主要論點。' },
                    { question: '我確信我能評估文中用來支持說法的資料。' },
                    { question: '我有信心能從線上閱讀材料中篩選出我需要的材料。' },
                    { question: '我知道我能辨別不同文本之間的關係。' }
                ]
            }
        ],
        [
            {
                id: 'C',
                title: 'C　線上閱讀的成本',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '要在線上閱讀中表現得好，需要付出的精力比我願意付出的還要多。' },
                    { question: '對我來說，要在線上閱讀中取得好成績，需要付出太多精力。' },
                    { question: '對我來說，要想做好線上閱讀，需要花費太多的精力。' }
                ]
            },
        ],
        [
            {
                id: 'D',
                title: 'D　線上閱讀能力看法',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '通過努力，我可以顯著地改變自己的線上閱讀能力。' },
                    { question: '我能夠大幅改變自己的線上閱讀能力。' },
                    { question: '無論我目前的線上閱讀能力如何，我都可以讓它有很大的改變。' }
                ]
            }
        ],
        [
            {
                id: 'E',
                title: 'E　對線上資訊的判斷',
                hint: '以下題目詢問你平時進行線上閱讀時，如何判斷資訊是否可靠。<br/>請根據你平時的想法與通常做法，你在多大程度上同意或不同意以下陳述？',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '當我在線上閱讀時，我會評估該資訊是否與我自己的理解一致。' },
                    { question: '為了檢查我在線上閱讀的資訊是否可靠，我會根據自己已有的知識來評估。' },
                    { question: '我會評估我在線上閱讀的資訊是否合乎邏輯。' },
                    { question: '在線上閱讀時，我會檢查該資訊是否與我已經知道的內容相符。' },
                    { question: '在線上閱讀時，我會查閱同一主題的多個資訊來源，評估讀到的說法。' },
                    { question: '當我在線上閱讀時，我會比較不同網站或來源對同一內容的說法。' }
                ]
            },
        ],
        [
            {
                id: 'F',
                title: 'F　對線上資訊的判斷',
                hint: '以下題目詢問你平時進行線上閱讀時，如何判斷資訊是否可靠。<br/>請根據你平時的想法與通常做法，你在多大程度上同意或不同意以下陳述？',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '為了評估線上資訊是否可靠，我會檢查它是否與其他網站或來源上的資訊一致。' },
                    { question: '為了判斷我在線上閱讀的資訊是否值得信賴，我會將它與多個來源的資訊進行比較。' },
                    { question: '在線上閱讀時，我會評估該資訊是否由專家撰寫。' },
                    { question: '為了判斷線上資訊是否值得信任，我會評估作者是否對該主題有足夠的知識。' },
                    { question: '當我在線上閱讀時，我會檢查該資訊是否來自專家來源。' },
                    { question: '為了評估線上資訊是否可靠，我會試著判斷作者是否在相關領域具備高度專業能力。' }
                ]
            }
        ],
        [
            {
                id: 'G',
                title: 'G　線上閱讀中的困難與壓力',
                hint: '進行線上閱讀時，你在多大程度上同意或不同意以下陳述？',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '我很擅長應對線上閱讀中遇到的挫折（例如，分數不理想、收到對自己閱讀表現的負面評價）。' },
                    { question: '我不會被線上閱讀帶來的壓力壓倒。' },
                    { question: '我認為自己很擅長處理線上閱讀帶來的壓力。' },
                    { question: '我不會讓線上閱讀中不理想的分數影響我的信心。' }
                ]
            },
        ],
        [
            {
                id: 'H',
                title: 'H　線上閱讀中的思考方式',
                hint: '進行線上閱讀時，你在多大程度上同意或不同意以下陳述？',
                options: [
                    '非常不同意',
                    '不同意',
                    '既不同意也不反對',
                    '同意',
                    '非常同意'
                ],
                questions: [
                    { question: '面對新的資訊時，我能很容易地調整自己的想法。' },
                    { question: '處理問題時，我能從不同角度思考。' },
                    { question: '我會按照不同情況的要求，調整自己的處理方式。' },
                    { question: '我能整合不同方面的知識來應對複雜的挑戰。' }
                ]
            }
        ]
    ]
}
